export default __webpack_public_path__ + "static/media/KFOkCnqEu92Fr1Mu51xMIzIXKMnyrYk.f03043aa.woff2";